export const paginateCars = (carPage, setCarPage, filteredCars, CARS_PER_PAGE) => {
  const totalPages = Math.ceil(filteredCars.length / CARS_PER_PAGE);
  if (carPage > totalPages) setCarPage(1);
  return filteredCars.slice((carPage - 1) * CARS_PER_PAGE, carPage * CARS_PER_PAGE);
};